






































































// Vue
import { Vue, Component, Watch } from 'vue-property-decorator'

// components
import { Select2, Input } from '@/components/form'

// models
import { DeviceModel } from '@/models/config'
import { PropOptionSelect } from '@/models'

// services
import { DeviceService } from '@/services/config'

@Component({
    name: 'DevicesSectionForm',
    components: {
        Select2,
        Input
    }
})
export default class DevicesSectionForm extends Vue {
    devices: DeviceModel[] = []
    devicesSelected: number[] = []
    password = ''
    name = ''

    async created () {
        this.devices = await DeviceService.getAllActivedAndConnected()
    }

    get devicesOptions (): PropOptionSelect[] {
        return this.devices.map(device => {
            return {
                value: device.id,
                text: device.name
            }
        })
    }

    @Watch('devicesSelected', { immediate: true, deep: true })
    changeDevices (newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.$emit('change-devices', {
                devices: this.devicesSelected,
                password: this.password
            })
        }
    }

    @Watch('password', { immediate: true, deep: true })
    changePassword (newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.$emit('change-devices', {
                devices: this.devicesSelected,
                password: this.password,
                name: this.name
            })
        }
    }
}
